// @flow
import {observable, when} from 'mobx'
import componentStore from 'stores/components'
import alertStore from 'stores/alert'
import type {Component} from 'entities'

export type Store = {
  activeId: null | string,
  mounted: boolean,
  pendingResult: null | any,
  setComponent: (id:string) => void,
  clear: () => void,
  save: () => void
}

const store:Store = observable(({
  activeId: null,
  mounted: false,
  pendingResult: null,
  setComponent(id){
    if(!store.mounted){
      when(() => store.mounted, ():any => {
        setTimeout(() => store.setComponent(id), 300)
      })
      return
    }
    store.activeId = id
    const iframe = document.getElementsByTagName('iframe')[0]
    const component = componentStore.byId[id]
    iframe.contentWindow.postMessage(JSON.stringify({
      id: 'rlx-storybook-select-component',
      component: component
    }), '*')
  },
  clear(){
    store.activeId = null
  },
  save(){
    const result = store.pendingResult
    if(!result) return
    const component:Component = {
      id: result.id,
      props: result.props,
      name: result.name
    }
    const gridArea = component.props.gridArea
    const id = component.id
    if(componentStore.components.find(comp => comp.props.gridArea === gridArea && comp.id !== id)) {
      return alertStore.set({
        title: 'Fehler',
        body: `Bitte vergebe eine eindeutige GridArea! "${gridArea}" wird bereits benutzt`
      })
    }
    else if(!gridArea.match("^[A-z0-9-]+$")) {
      return alertStore.set({
        title: 'Fehler',
        body: `Die GridArea "${gridArea}" enthält ungültige Zeichen. Es sind nur Zahlen, Buchstaben und "-" erlaubt`
      })
    }
    else {
      componentStore.setComponent(component)
      store.activeId = null
      store.pendingResult = null
    }
  }
}:Store))

// listener
window.addEventListener('message', e => {
  if(typeof e.data !== 'object') return

  switch(e.data.id){
    case 'rlx-storybook-request-component': {
      store.mounted = true
      console.log('storybook has mounted')
    }
    case 'rlx-storybook-update-component': {
      store.pendingResult = e.data.component || null
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/stores/storybook.js